import React, {Component} from 'react';
import {Grid} from 'semantic-ui-react';

export default class ContactInfo extends Component{

	render(){
		let {photo, caption} = this.props
		return (
			<Grid>
				<Grid.Column width={3}>
					<img src={photo} alt="" className="icn-contact-us margin-bottom-5"/>
				</Grid.Column>
				<Grid.Column width={13} className="contact-info-wrapper">
					{caption.map((paragraph, i) => (
						<div className="para-content" key={i}>{paragraph}</div>
						)
					)}
				</Grid.Column>
			</Grid>
		);
	}
}